import http from "./httpService";

export function getQuickLinksArchitectures() {
  return http.get("/quick-links-architectures");
}